import { forwardRef, HTMLProps } from 'react';

interface PropTypes extends HTMLProps<HTMLDivElement> {
  children: string;
}

const Html = forwardRef<HTMLDivElement, PropTypes>(
  ({ children, ...restProps }, ref) => (
    <div
      dangerouslySetInnerHTML={{ __html: children }}
      {...restProps}
      ref={ref}
    />
  )
);

Html.displayName = 'Html';

export default Html;
